import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pb-team-member',
  templateUrl: './pb-team-member.component.html',
  styleUrls: ['./pb-team-member.component.scss']
})
export class PbTeamMemberComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    items: any = [];
    domainUrl: string = environment.webUrl;

    constructor() { }

    ngOnInit(): void {

        this.content.forEach(element => {
            var item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            }

            if (element.item.type == 'IMAGE') {
                item.content = this.domainUrl + '/' + element.data;
            }

            this.items.push(item);
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'text-left';
        } else if (alignment == 'CENTER') {
            return 'text-center';
        } else if (alignment == 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

}
